import { render, staticRenderFns } from "./StarterPackCarouselNav.vue?vue&type=template&id=31312ec5&scoped=true"
import script from "./StarterPackCarouselNav.vue?vue&type=script&lang=js"
export * from "./StarterPackCarouselNav.vue?vue&type=script&lang=js"
import style0 from "./StarterPackCarouselNav.vue?vue&type=style&index=0&id=31312ec5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31312ec5",
  null
  
)

export default component.exports